import React, { useEffect, useState } from "react";

/* -------- framework elements -------- */
import { dictionary } from "../../../utils/dictionary";
/* -------- ------- -------- */

/* -------- packages -------- */
import * as Yup from "yup";
import {  Modal, ModalHeader, ModalBody, FormFeedback, Spinner } from "reactstrap";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import {
  Input
} from "reactstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { clearProjectErrors, updateProjectRequest } from "../../../store/actions";
import { useFormik } from "formik";
/* -------- ------- -------- */

/* -------- components -------- */

/* -------- ------- -------- */

/* -------- intern functions -------- */
/* -------- ------- -------- */

export default function NewProjectModal ({isModalOpen, setModalOpen, projToEdit}) { // isModalOpen (BOOLEAN), setModalOpen (useState Function(true/false))
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const user = useSelector(state => state.Login.user);
    const parameters = useSelector(state => state.Parameters);
    const projectsList = useSelector(state => state.Projects.projects);
    
    // Ajout de la sélection des erreurs du store ET du loading state
    const errorProject = useSelector(state => state.Projects.errorProject);
    const loadingProject = useSelector(state => state.Projects.loadingProject);

    const [editProject, setEditProject] = useState(false);    
    
    const projectForm = useFormik({
      enableReinitialize: true,
    
      initialValues: {
        projectLib: editProject ? editProject.lib : '',
      },
      validationSchema: Yup.object({
        projectLib: Yup.string().required( t('REQUIRED'))
      }),
      onSubmit: (values) => {
        editProject ? handleEditProject() : handleCreateProject();
      },
    });

    useEffect(() => {
      if(projToEdit) {
        return setEditProject(projToEdit);
      }

      if(isModalOpen == false) {
        projectForm.resetForm();
        setEditProject(null);
        // Nettoyer les erreurs quand on ferme le modal
        dispatch(clearProjectErrors());
      }
    }, [isModalOpen, projectsList.length])

    // Gestion des erreurs du store Redux (comme dans DynamicForm)
    useEffect(() => {
      if (errorProject && errorProject.data && errorProject.data.errors) {
        errorProject.data.errors.forEach(err => {
          if (err.code && err.key) {
            // Mapper la clé de l'erreur vers le nom du champ dans le formulaire
            const fieldKey = err.key === 'lib' ? 'projectLib' : err.key;
            projectForm.setFieldError(fieldKey, t(err.code));
          }
        });
      }
    }, [errorProject]);
    
    const handleCreateProject = () => {
      // Marquer tous les champs comme touchés si erreur
      if (!projectForm.values.projectLib || projectForm.errors.projectLib) {
        projectForm.setTouched({ projectLib: true });
        toast.error(t(projectForm.errors.projectLib || 'REQUIRED'));
        dispatch(clearProjectErrors());
        return;
      }

      const values = {
        lib: projectForm.values.projectLib,
        status: dictionary.projProject.statusPending,
        userId: user.id
      };

      dispatch(updateProjectRequest(values));
    };

    const handleEditProject = () => {
      // Marquer tous les champs comme touchés si erreur
      if (!projectForm.values.projectLib || projectForm.errors.projectLib) {
        projectForm.setTouched({ projectLib: true });
        toast.error(t(projectForm.errors.projectLib || 'REQUIRED'));
        dispatch(clearProjectErrors());
        return;
      }

      const values = {
        lib: projectForm.values.projectLib,
        status: editProject.status,
        id: editProject.id
      };

      dispatch(updateProjectRequest(values));
    };


    return (
      <Modal isOpen={isModalOpen} toggle={() => setModalOpen(false)} centered={true} size={'xl'} scrollable={true} className="newProjectModal">
        <ModalHeader toggle={() => setModalOpen(false)}>
          {
            (editProject) ?
            `${t('editProject')}`
            :
            `${t('newProject')}`
          }
          </ModalHeader>
        <ModalBody>
          <div className="container">
                <div className="card">
                      <div className="card-body newProjectBody">
                        <div className="row title">
                          { (editProject) ?
                            <h4>{t('editProjectQuestion')}</h4>
                            :
                            <h4>{t('newProjectQuestion')}</h4>
                          }
                        </div>
                        
                        <div className="row inputContainer">
                            <Input
                            name="projectLib"
                            className="input-projectLib"
                            autoComplete="on"
                            placeholder={parameters.appName}
                            value={projectForm.values.projectLib || ""}
                            type="text"
                            onChange={projectForm.handleChange}
                            onBlur={projectForm.handleBlur}
                            invalid={projectForm.touched.projectLib && projectForm.errors.projectLib ? true : false}
                            disabled={loadingProject} 
                          />
                          {projectForm.touched.projectLib && projectForm.errors.projectLib ? 
                            (
                            <FormFeedback type="invalid" id="projFormFeedbackprojectLib" data-cy="signin-projectLibError">
                              {projectForm.errors.projectLib}
                            </FormFeedback>
                            ) 
                            : null
                          }
                        </div>

                        <div className="row">
                          <div className="card-footer">

                            <button 
                              className="btn btn-secondary" 
                              onClick={() => {setModalOpen(false)}}
                              disabled={loadingProject} 
                            >
                              {t('cancel')}
                            </button>
                            
                            { (editProject) ?
                              <button 
                                className="btn btn-primary" 
                                onClick={() => {handleEditProject()}}
                                disabled={loadingProject} 
                              >
                                {loadingProject ? (
                                  <>
                                    <Spinner size="sm" className="me-2" />
                                  </>
                                ) : (
                                  t('validate')
                                )}
                              </button>
                              :
                              <button 
                                className="btn btn-primary" 
                                onClick={() => {handleCreateProject()}}
                                disabled={loadingProject} 
                              >
                                {loadingProject ? (
                                  <>
                                    <Spinner size="sm" className="me-2" />
                                  </>
                                ) : (
                                  t('validate')
                                )}
                              </button>
                            }
                          </div>
                        </div>
                      </div>  
                </div>
          </div>
        </ModalBody>
      </Modal>
    )

}